import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeBackNudgeComponent } from './welcome-back-nudge.component';
import { ImgLoaderDirective } from 'src/app/shared/directives/img-loader.directive';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    WelcomeBackNudgeComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [WelcomeBackNudgeComponent]
})
export class WelcomeBackNudgeModule {
  getComponent() {
    return WelcomeBackNudgeComponent;
  }
}
